import FormattedMessage from 'I18n/components/FormattedMessage';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import DataSyncTileIllustration from './DataSyncTileIllustration';
import { DataSyncOptionAppsConfigs } from '../../constants/dataSyncConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataSyncTile = ({
  app,
  ButtonComponent = SelectableButton,
  href,
  size = 'default',
  rootNode,
  onOneClickAuthError,
  onOneClickAuthSuccess,
  onOneClickAuthStatusChange,
  onOneClickConnectionError,
  onClick
}) => {
  const {
    illustrationProps,
    smallTextMessageKey,
    textMessageKey
  } = DataSyncOptionAppsConfigs[app];
  const isSmallSize = size === 'sm';
  const titleMessageKey = isSmallSize && smallTextMessageKey ? smallTextMessageKey : textMessageKey;
  const appName = app.toLowerCase().replaceAll(' ', '-');
  return /*#__PURE__*/_jsx(Link, {
    "data-test-id": `${appName}-data-sync-link`,
    href: href,
    target: "_top",
    use: "unstyled",
    children: /*#__PURE__*/_jsx(ButtonComponent, {
      app: app,
      "data-test-id": `${appName}-data-sync-tile`,
      padding: isSmallSize ? '200' : '400',
      rootNode: rootNode,
      onAuthenticationStatusChange: onOneClickAuthStatusChange,
      onAuthenticationSuccess: onOneClickAuthSuccess,
      onAuthenticationError: onOneClickAuthError,
      onConnectionError: onOneClickConnectionError,
      onClick: onClick,
      children: /*#__PURE__*/_jsxs(Flex, {
        inlineSize: isSmallSize ? '124px' : '144px',
        blockSize: isSmallSize ? '124px' : '144px',
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(DataSyncTileIllustration, Object.assign({
          isSmallSize: isSmallSize
        }, illustrationProps)), /*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          marginBlockEnd: "100",
          marginBlockStart: isSmallSize ? '200' : '300',
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: titleMessageKey
          })
        })]
      })
    })
  });
};
export default DataSyncTile;